import { ProductFeatureDTO } from "../domain/models/dto/ProductFeatureDTO";
import { ProductFeaturesCollection } from "../domain/models/ProductFeature";
import { ProductFeaturesService } from "../domain/services/ProductFeaturesService";
import { BaseServiceImpl } from "./BaseServiceImpl";

export class ProductFeaturesServiceImpl
    extends BaseServiceImpl
    implements ProductFeaturesService
{
    static _instance: ProductFeaturesService;
    private readonly featuresEndpoint = "/api/v1/features";

    private constructor() {
        super();
    }

    static getInstance(): ProductFeaturesService {
        if (!ProductFeaturesServiceImpl._instance) {
            ProductFeaturesServiceImpl._instance =
                new ProductFeaturesServiceImpl();
        }
        return ProductFeaturesServiceImpl._instance;
    }

    async getAllProductFeaturesService(
        currentPage: number,
        currentLimit: number,
        filtersDTO: ProductFeatureDTO = {} as ProductFeatureDTO
    ): Promise<ProductFeaturesCollection> {
        try {
            let url = `${this.featuresEndpoint}?limit=${currentLimit}&page=${currentPage}`;
            Object.entries(filtersDTO).forEach(([key, value]) => {
                if (key && value !== null && value !== undefined) {
                    url += `&${key}=${value}`;
                }
            });

            return await this.get<ProductFeaturesCollection>(url);
        } catch (err) {
            console.log("Error in ProductFeaturesServiceImpl.getAllRoles");
            console.log(err);
        }
    }
}

export function productFeaturesServiceFactory(): ProductFeaturesService {
    return ProductFeaturesServiceImpl.getInstance();
}
